import { render, staticRenderFns } from "./centerLeft8.vue?vue&type=template&id=22b4c89c&scoped=true&"
import script from "./centerLeft8.vue?vue&type=script&lang=js&"
export * from "./centerLeft8.vue?vue&type=script&lang=js&"
import style0 from "./centerLeft8.vue?vue&type=style&index=0&id=22b4c89c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b4c89c",
  null
  
)

export default component.exports